import { render, staticRenderFns } from "./BrandPanelColorEdit.vue?vue&type=template&id=a3e228f2&"
import script from "./BrandPanelColorEdit.vue?vue&type=script&lang=ts&"
export * from "./BrandPanelColorEdit.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPanelColorEdit.vue?vue&type=style&index=0&id=a3e228f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports